import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

interface BreadcrumbsProps {
  crumbs: { slug: string; title: string }[]
}

export function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
  if (crumbs.length === 0) return null

  return (
    <nav className="flex items-center gap-1 text-sm text-muted-foreground mb-4 flex-wrap">
      <Link
        to="/guide"
        className="hover:text-foreground transition-colors"
      >
        Guide
      </Link>
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1
        return (
          <span key={crumb.slug} className="flex items-center gap-1">
            <ChevronRight className="w-3.5 h-3.5 flex-shrink-0" />
            {isLast ? (
              <span className="text-foreground font-medium">{crumb.title}</span>
            ) : (
              <Link
                to={`/guide/${crumb.slug}`}
                className="hover:text-foreground transition-colors"
              >
                {crumb.title}
              </Link>
            )}
          </span>
        )
      })}
    </nav>
  )
}
